import { NavigationItems } from './navigation-items';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '../ui/sidebar';
import { NavProfile } from './profile-navigation';
import { Logo } from '../logo';

export const SideMenu = () => {
  return (
    <Sidebar data-testid="navigation">
      <SidebarHeader>
        <div className="inline-flex">
          <Logo className="h-12 my-4" />
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavigationItems />
      </SidebarContent>
      <SidebarFooter>
        <NavProfile />
      </SidebarFooter>
    </Sidebar>
  );
};
